import { makeStyles } from 'tss-react/mui';
import {
  ROOM_ITEM_BACKGROUND_COLOR_WITHOUT_NOTIFICATION,
  ROOM_ITEM_BACKGROUND_COLOR_WITH_NOTIFICATION,
} from '../../../../../utils/styles.const';

interface UseGroupedRoomItemStylesParams {
  hasNotification: boolean;
}

export const useGroupedRoomItemStyles = makeStyles<UseGroupedRoomItemStylesParams>()(
  (theme, { hasNotification }) => ({
    button: {
      backgroundColor: hasNotification
        ? ROOM_ITEM_BACKGROUND_COLOR_WITH_NOTIFICATION
        : ROOM_ITEM_BACKGROUND_COLOR_WITHOUT_NOTIFICATION,
      padding: '16px 20px',
      display: 'flex',
      height: '64px',
      width: '100%',
      flexDirection: 'row',
      boxSizing: 'border-box',
      justifyContent: 'space-between',
      borderRadius: '0px',

      [theme.breakpoints.down('sm')]: {
        height: '64px',
      },
    },
  }),
);
